import {CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize, useDeviceSize} from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    container: {
      paddingLeft: 30,
      width: "100%",
    },
    inputWidget:{
      width: "70%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    alertModalWrapper:{
      backgroundColor: "white",
      width: 323,
      height: 200,
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    paymentMethodInfoBar: {
      flexDirection: "row",
      flexWrap: "wrap",
      borderRadius: 15,
      marginTop: 20.5,
      width: "100%",
      minHeight: 75.5,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    paymentMethodIcons: {
      backgroundColor: "#fff",
      borderTopLeftRadius: 9.2,
      borderBottomLeftRadius: 9.2,
    },
    userDetailsViewStyle: {
      display: "flex",
    },
    InfoBarMessage: {
      backgroundImage: "linear-gradient(94deg, #d14a27 0%, #e89b61 100%)",
      flex: 1,
      justifyContent: "center",
      borderTopRightRadius: 9.2,
      borderBottomRightRadius: 9.2,
      paddingLeft: 36.9,
      paddingRight: 30,
    },
    InfoBarTitle: {
      fontFamily: "Inter",
      fontSize: 22,
      lineHeight: 27,
      color: "#ffffff",
      fontWeight: "light",
    },
    infobarTitleTab: { fontSize: 12, lineHeight: 15 },
    InfoBarTitleBold: {
      fontWeight: "bold",
    },
    InfoBarLogo: {
      width: 198.7,
      height: "100%",
      borderTopLeftRadius: 9.2,
      borderBottomLeftRadius: 9.2,
    },
    rechargeBody: {
      width: "100%",
      backgroundColor: "#fff",
      borderRadius: 15,
      marginTop: 25.5,
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
    },
    r0: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 20,
      paddingLeft: 35,
      paddingRight: 35,
    },
    rechargeBodyTitle: {
      flexDirection: "row",
      alignItems: "center",
    },
    // backbutton: {
    //   width: 19,
    //   height: 19,
    //   marginRight: 20,
    //   paddingTop: 5.4,
    //   paddingRight: 7.7,
    //   paddingBottom: 5.8,
    //   paddingLeft: 6.7,
    // },
    rechargeBodyHeading: {
      fontFamily: "Inter",
      fontSize: 13,
      color: "#999",
    },
    r1: {
      marginTop: 28,
      flexDirection: "row",
      position: "relative",
      zIndex: 1,
    },
    rbr1c1: {
      width: "50%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    rbLabel: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#757575",
      textAlign: "right",
      position: "relative",
      zIndex: 1,
      marginRight: 20,
    },
    dropDownViewStyle: {
      width: 230,
      height: 40,
      marginLeft: 20,
      position: "relative",
      zIndex: 9999,
      opacity: 1,
      backgroundColor: "#fff",
    },
    dropdownHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      zIndex: 999,
      border: "2px solid #dfdfdf",
      padding: 10,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      borderBottomWidth: 0,
    },
    dropdownHeaderHide: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      zIndex: 999,
      border: "2px solid #dfdfdf",
      padding: 10,
      borderRadius: 12,
    },
    dropdownLabel: {
      fontFamily: "Inter",
      fontSize: 14,
      lineHeight: 20,
      color: "#757575",
      textAlign: "right",
    },
    showDropdown: {
      display: "flex",
      border: "2px solid #dfdfdf",
      height: 200,
      overflow: "scroll",
      width: 230,
      position: "absolute",
      top: 40,
      zIndex: 99,
      backgroundColor: "#fff",
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      boxShadow: "0 11px 11px 0 rgba(0, 0, 0, 0.16);",
    },
    hideDropdown: { display: "none" },
    rbr1c2: {
      width: "50%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: 40,
    },
    availBal: {
      width: 111.3,
      height: 39.5,
      border: "solid 1px #c3c3c3",
      borderRadius: 12,
      justifyContent: "center",
      alignItems: "center",
      marginLeft: 19,
      backgroundColor: "#f8f8f8",
    },
    balAmt: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      color: "#4cbb40",
    },
    balAmtEmpty: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      color: "#c3c3c3",
    },
    r2: {
      marginTop: 22,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    amtBox: {
      width: 230,
      height: 40,
      padding: 10,
      borderRadius: 12,
      border: "2px solid #dfdfdf",
      marginLeft: 20,
      justifyContent: "center",
    },
    r3: {
      marginTop: 13,
      flexDirection: "row",
    },
    rbr3c1: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      width: "50%",
      height: "100%",
    },
    rbLabelSmall: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 300,
      color: "#757575",
      marginRight: 12.2,
    },
    quickAddButton: {
      width: 65,
      height: 23.5,
      backgroundColor: "#ffdfe2",
      borderRadius: 12,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 8.8,
    },
    qabInnerText: {
      fontFamily: "Inter",
      fontSize: 10,
      color: "#9b1e27",
    },
    rbr3c2: {
      width: "50%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
    },
    r4: {
      width: "50%",
      marginTop: 22.5,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    rechargeButton: {
      width: 230,
      height: 40,
      borderRadius: 22,
      backgroundColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "center",
      boxShadow: "0 12px 24px 0 rgba(189, 45, 55, 0.4)",
    },
    rechargeButtonInnerText: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: 600,
      color: "#fff",
    },
    r5: {
      width: "100%",
      marginTop: 32,
      border: "1px solid #eee",
      borderLeftWidth: 0,
      borderBottomWidth: 0,
      borderRightWidth: 0,
      flexDirection: "row",
      paddingBottom: 30,
      paddingTop: 21.5,
      justifyContent: "space-between",
      paddingLeft: 35,
      paddingRight: 35,
    },
    linkbox: {
      justifyContent: "center",
      alignItems: "center",
    },
    // chainLink: {
    //   width: 17.9,
    //   height: 22.2,
    
    // },
    chainLabel: {
      fontFamily: "Inter",
      fontSize: 11,
      color: "#30424e",
      marginTop: 7.5,
    },

    linkSet: {
      flexDirection: "column",
      justifyContent: "space-around",
    },

    oneLink: {
      fontFamily: "Inter",
      fontSize: 13,
      color: "#30424e",
    },

    mr: {
      marginTop: 30,
      flexDirection: "row",
      alignItems: "center",
    },
    mc1: {
      width: "30%",
    },
    mc2: {
      width: "70%",
      paddingLeft: 15,
    },
    mrdd: { position: "relative", zIndex: 1 },
    mc1dd: { position: "relative", zIndex: 1 },
    mc2dd: { position: "relative", zIndex: 1 },
    quickAddLabel: {
      paddingLeft: 20,
    },
    quickAddButtons: {
      flexDirection: "row",
      paddingLeft: 12,
      paddingTop: 10,
    },
    rbm: {
      paddingLeft: 18,
      position: "relative",
      zIndex: 1,
    },
    r5s: {
      marginTop: 15,
      border: "1px solid #eee",
      borderLeftWidth: 0,
      borderBottomWidth: 0,
      borderRightWidth: 0,
      paddingBottom: 30,
      paddingTop: 21.5,
      paddingLeft: 20,
      display: "none",
    },
    sr: {
      marginTop: 30,
      marginLeft: 20,
    },
    rbLabels: { textAlign: "left", marginBottom: 5 },
    dropDownViewStyles: {
      marginLeft: 0,
      position: "relative",
      zIndex: 999,
      width: 230,
      height: 40,
      opacity: 1,
      backgroundColor: "#fff",
    },
    availBals: { marginLeft: 0 },
    amtBoxs: { marginLeft: 0 },
    quickAddButtonss: {
      flexDirection: "row",
      paddingTop: 10,
    },
    qabs: {
      width: 65,
      height: 23.5,
      backgroundColor: "#ffdfe2",
      borderRadius: 12,
      alignItems: "center",
      justifyContent: "center",
      marginRight: 10,
    },
    qabls: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 300,
      color: "#757575",
      marginLeft: 0,
      marginTop: -10,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    footer: {
      width: "100%",
      bottom: 0,
      paddingVertical: 10,
      alignItems: "center",
    },
  },
  {
    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        paddingLeft: 0,
        marginLeft: 0,
        width: "100%",
        paddingRight: 10,
      },
      InfoBarLogo: {
        width: 150.7,
        height: 56.8,
      },
      InfoBarTitle: {
        fontSize: 9,
        lineHeight: 14,
      },
      InfoBarMessage: { paddingLeft: 15 },
      userDetailsViewStyle: {
        display: "none",
      },
      paymentMethodInfoBar: { marginLeft: 10, marginTop: 10 },
      rechargeBody: { marginLeft: 10 },
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: { paddingLeft: 37.2 },
      paymentMethodInfoBar: { marginTop: 0 },
      InfoBarLogo: {
        width: 171.7,
        height: 64.77,
      },
      InfoBarTitle: {
        fontSize: 12,
        lineHeight: 15,
      },
      InfoBarMessage: { paddingLeft: 15 },
      r1: {
        flexDirection: "column",
      },
      rb1c1: {
        width: "75%",
        alignItems: "flex-start",
      },
      rb1c2: {
        width: "75%",
        justifyContent: "flex-start",
      },
      userDetailsViewStyle: {
        display: "none",
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      container: {
        paddingLeft: 0,
        marginLeft: 0,
        width: "100%",
        paddingRight: 10,
      },
      InfoBarLogo: {
        width: 150.7,
        height: 56.8,
      },
      InfoBarTitle: {
        fontSize: 9,
        lineHeight: 14,
      },
      InfoBarMessage: { paddingLeft: 15 },
      userDetailsViewStyle: {
        display: "none",
      },
      r5s: {
        display: "flex",
      },
      paymentMethodInfoBar: { marginLeft: 10, marginTop: 10 },
      rechargeBody: { marginLeft: 10 },
    },

    [minSize(DEVICE_SIZES.LG)]: {
      paymentMethodInfoBar: {
        flexDirection: "row",
      },
    },
  }
);
export default useStyles;
